module.exports = require('react/lib/LinkedStateMixin');